import { cn } from "@design-system/utils";
import { trans } from "@mongez/localization";
import { useNavigate } from "@remix-run/react";
import { ChevronLeftIcon } from "../Icons";
import { Button, ButtonProps } from "./Button";

type BackButtonProps = ButtonProps;

export function BackButton({ className, ...props }: BackButtonProps) {
  const navigate = useNavigate();

  return (
    <Button
      {...props}
      variant="outline"
      className={cn("group gap-2", className)}
      onClick={() => navigate(-1)}
    >
      <ChevronLeftIcon className="transition group-hover:-translate-x-1" />
      {trans("back")}
    </Button>
  );
}
